import { Component, Input } from '@angular/core';

export interface ActivityEventFeed {
  module?: string;
  timestamp: string;
  action: string;
  user: {
    uid: string;
    name: string;
  };
}

@Component({
  selector: 'app-activity-feed',
  templateUrl: './activity-feed.component.html',
  styleUrls: ['./activity-feed.component.sass'],
})
export class ActivityFeedComponent {
  @Input() eventsFeed: ActivityEventFeed[] | undefined;
}
